import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Form, FormCheckbox, FormSubmitBack, FormText, FormTextArea } from '../../../../../shared/form/form'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { Card } from '../../../../../shared/card/card'
import { IconEdit } from '../../../../../shared/icon/icon'
import { useApiFormRoleOrg } from '../../../../../api-new/state/content'
import { serverMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

// The owner role is locked: the role that is the owner role stays it, and no
// other role can become it (the content API answers 409 role.owner_locked /
// role.owner_unique). Its name and permissions stay editable.
// The hints are the content API's 409 messages word for word
// (rapid-api-content domain/role-org owner_lock.go): role.owner_locked and
// role.owner_unique.
export const OWNER_ROLE_LOCKED_HINT = "Every organization needs an owner role, so Auto Owner can't be turned off on this role. You can still rename it or change its permissions."
export const OWNER_ROLE_ONLY_HINT = 'Another role is already the owner role, and only one role can be.'

export const RoleOrgEdit = () => {
	const { roleOrgID } = useParamsInt()

	const apiFormRoleOrg = useApiFormRoleOrg()

	const handlePath = () => apiFormRoleOrg.get(roleOrgID)

	const [error, failure, setError] = useErrorLine()

	const handleSubmit = async (data) => {
		setError(null)
		try {
			return await apiFormRoleOrg.put(data.id, data)
		} catch (err) {
			setError(serverMessage(err, "The role couldn't be updated."), err)
		}
	}

	const isOwnerRole = !!apiFormRoleOrg.form.isAutoOwner

	const title = useMemo(() => `${apiFormRoleOrg.form.name}`, [apiFormRoleOrg.form])

	return (
		<React.Fragment>
			<BreadcrumbView Icon={IconEdit} text={title} onPath={handlePath}>
				<Card title='edit role'>
					{error && <p className='text-danger' role='alert'>{error}</p>}
					{error && <ErrorReference error={failure} className='mb-3' />}
					<Form state={apiFormRoleOrg.form} onSubmit={handleSubmit}>
						<FormText label='ronamele' name='name' autoFocus />
						<FormTextArea label='description' name='description' />
						<FormCheckbox label='Auto Owner' name='isAutoOwner' disabled />
						<div className='form-text mt-n2 mb-2 ms-4' data-testid='auto-owner-hint'>
							{isOwnerRole ? OWNER_ROLE_LOCKED_HINT : OWNER_ROLE_ONLY_HINT}
						</div>
						<FormCheckbox label='Auto User' name='isAutoUser' />
						<FormCheckbox label='Read Only' name='isReadOnly' />
						<FormSubmitBack text='update role' />
					</Form>
				</Card>
			</BreadcrumbView>
		</React.Fragment>
	)
}
